import { render, staticRenderFns } from "./my-uploadOnly.vue?vue&type=template&id=a7294974&scoped=true"
import script from "./my-uploadOnly.vue?vue&type=script&lang=js"
export * from "./my-uploadOnly.vue?vue&type=script&lang=js"
import style0 from "./my-uploadOnly.vue?vue&type=style&index=0&id=a7294974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7294974",
  null
  
)

export default component.exports